/* FAQ simple — accordion tween + one-open-at-a-time.

   Why the height is animated from script: a closed <details> keeps its content
   unrendered, so a CSS transition has no "before" size to run from and the
   panel snaps. The CSS-only cure (::details-content + interpolate-size +
   @starting-style) is Chromium-only, and interpolating grid-template-rows needs
   Safari 16+. Measuring the panel and animating an explicit pixel height runs
   in Chrome and Safari alike, on both viewports, and survives interruption —
   re-opening mid-collapse picks the tween up at the height on screen.

   Nothing is committed inline: the Web Animation owns the height for its 280ms
   and the panel settles back to auto height, so it keeps reflowing on resize. */
(function () {
  var ROOT = '.trinsic-faq-simple';
  var ITEM = '.trinsic-faq-simple__item';
  var WRAP = '.trinsic-faq-simple__answer-wrap';
  var INIT = 'trinsicFaqInited';
  var DURATION = 280;
  var EASING = 'cubic-bezier(0.33, 0, 0.2, 1)';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function canAnimate(wrap) {
    if (reduceMotion && reduceMotion.matches) return false;
    return typeof wrap.animate === 'function';
  }

  /* Height the panel is painting at RIGHT NOW — mid-tween included. */
  function currentHeight(wrap) {
    return wrap.getBoundingClientRect().height;
  }

  /* Cancelling reverts the wrap to its underlying auto height in the same task,
     so no frame is painted between stopping one tween and starting the next. */
  function stop(wrap) {
    if (wrap.trinsicFaqAnim) {
      wrap.trinsicFaqAnim.cancel();
      wrap.trinsicFaqAnim = null;
    }
  }

  function expand(item) {
    var wrap = item.querySelector(WRAP);
    delete item.dataset.faqClosing;
    item.classList.add('is-active');

    if (!wrap) {
      item.open = true;
      return;
    }

    var from = item.open ? currentHeight(wrap) : 0;
    stop(wrap);
    item.open = true; /* render the content before measuring it */

    if (!canAnimate(wrap)) return;

    var to = wrap.scrollHeight;
    if (to <= from) return;

    var anim = wrap.animate(
      [
        { height: from + 'px', opacity: from ? 1 : 0 },
        { height: to + 'px', opacity: 1 },
      ],
      { duration: DURATION, easing: EASING }
    );
    wrap.trinsicFaqAnim = anim;
    anim.onfinish = function () {
      wrap.trinsicFaqAnim = null;
    };
  }

  function collapse(item) {
    if (!item.open || item.dataset.faqClosing) return;

    var wrap = item.querySelector(WRAP);
    item.classList.remove('is-active');

    if (!wrap) {
      item.open = false;
      return;
    }

    var from = currentHeight(wrap);
    stop(wrap);

    if (!canAnimate(wrap)) {
      item.open = false;
      return;
    }

    item.dataset.faqClosing = 'true';

    var anim = wrap.animate(
      [
        { height: from + 'px', opacity: 1 },
        { height: '0px', opacity: 0 },
      ],
      { duration: DURATION, easing: EASING }
    );
    wrap.trinsicFaqAnim = anim;
    /* onfinish only — a cancel means expand() took over and now owns the state. */
    anim.onfinish = function () {
      wrap.trinsicFaqAnim = null;
      delete item.dataset.faqClosing;
      item.open = false;
    };
  }

  function init(root) {
    if (!root || root.dataset[INIT] === 'true') return;
    root.dataset[INIT] = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll(ITEM));

    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        /* Drive the toggle by hand — the native one flips [open] instantly and
           leaves nothing to animate. Enter/Space are covered: both fire a click
           on <summary>. */
        event.preventDefault();

        if (item.open && !item.dataset.faqClosing) {
          collapse(item);
          return;
        }

        /* One open at a time — the outgoing panel animates shut alongside. */
        items.forEach(function (other) {
          if (other !== item) collapse(other);
        });
        expand(item);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
